import React, { useState } from "react";
import { Form, Input } from "antd";
import { searchByRut } from './api';

export default function SearchByRut({ type, onSuccess, onError, label, name }) {
  const [searching, setSearching] = useState(false);

  const doSearch = (run) => {
    if ((run || "").trim().length === 0) return;

    setSearching(true);

    searchByRut(type, run)
      .then((result) => {
        if (result.entry.length) {
          onSuccess(result.entry[0].resource);
        } else {
          onError(run);
        }
      })
      .catch(onError)
      .finally(() => {
        setSearching(false);
      });
  };

  return (
    <Form.Item
      name={name}
      label={`RUN ${label}`}
      help="Sin puntos y guión, por ej: 11111111-1"
      rules={[{ required: true, message: "Es requerido" }]}
    >
      <Input.Search
        onPressEnter={(event) => {
          event.preventDefault();
          doSearch(event.target.value);
        }}
        loading={searching}
        allowClear
        onSearch={doSearch}
      />
    </Form.Item>
  );
}
